export const enum CTaxType {
  /** 1: 課税（標準） */
  _1_KAZEI_HYOJUN = 1,
  /** 2: 非課税 */
  _2_HI_KAZEI,
  /** 3: 対象外 */
  _3_TAISHO_GAI,
  /** 4: 課税（軽減） */
  _4_KAZEI_KEIGEN,
  /** 5: 課税（共通返還） */
  // _5_KAZEI_KYOTSU,
}

export function getCtaxTypeName(value: CTaxType | number | null) {
  switch (value) {
    case CTaxType._1_KAZEI_HYOJUN:
      return "課税（標準）";
    case CTaxType._2_HI_KAZEI:
      return "非課税";
    case CTaxType._3_TAISHO_GAI:
      return "対象外";
    case CTaxType._4_KAZEI_KEIGEN:
      return "課税（軽減）";
    // case CTaxType._5_KAZEI_KYOTSU:
    //   return "課税（共通返還）";
    default:
      return "";
  }
}
